import { lazy } from "react";
import { createFileRoute, useNavigate, useParams } from "@tanstack/react-router";
import { DocFilePicker } from "@client/components/doc-generation/doc-file-picker";
import { ProjectKbContent } from "@client/components/project/project-kb-content";
import {
  SsBidGenCreateTaskEmbed,
  SsBidGenResourceLibraryEmbed,
  SsBidGenStageEmbed,
} from "@client/components/ss-bid-gen/ss-bid-gen-embed";
import {
  ProjectWorkspace,
  type ProjectWorkspaceProps,
} from "@tubo/project-workspace";

/** Word 编辑器保持按需加载（源码体积大，不打进工作台主包）。 */
const LazyWordEditorSurface = lazy(() =>
  import("@tubo/word-editor").then(
    (module) => ({ default: module.WordEditorSurface }),
  ),
);

function ProjectWorkspaceRoute() {
  const { projectId } = useParams({ from: "/_workspace/projects/$projectId" });
  const navigate = useNavigate();

  const injection: Omit<ProjectWorkspaceProps, "projectId"> = {
    /** 退出工作区回工作台项目视图（显式导航，不依赖浏览器历史） */
    onExit: () => {
      navigate({ to: "/workbench", search: { view: "project" } });
    },
    onSwitchProject: (id) =>
      navigate({ to: "/projects/$projectId", params: { projectId: id } }),
    onOpenDocGen: (id) =>
      navigate({ to: "/doc-generation/create", search: { projectId: id } }),
    docFilePicker: DocFilePicker,
    wordEditorSurface: LazyWordEditorSurface,
    kbContent: ProjectKbContent,
    /** 标书生成嵌入：ss-bid-gen 组件（创建任务 / 六步阶段 / 租户资源库） */
    ssBidGenEmbed: {
      CreateTask: SsBidGenCreateTaskEmbed,
      Stage: SsBidGenStageEmbed,
      ResourceLibrary: SsBidGenResourceLibraryEmbed,
    },
  };

  return <ProjectWorkspace projectId={projectId} {...injection} />;
}

export const Route = createFileRoute("/_workspace/projects/$projectId")({
  component: ProjectWorkspaceRoute,
});
